module.exports = __webpack_public_path__ + "static/media/searchReg.bb891dbf.svg";